<template>
  <div class="mv-bg-main" style="overflow: scroll;">
    <el-card class="mr">
      <div class="left">
        <ve-ring :data-empty="incomeEmpty" :data="incomeData" :title="incomeTitle" :colors="color" :settings="chartSettings"></ve-ring>
      </div>
      <div class="left">
        <ve-ring :data-empty="costEmpty" :data="costData" :title="costTitle" :colors="color" :settings="chartSettings"></ve-ring>
      </div>
      <div class="left">
        <ve-ring :data-empty="profitEmpty" :data="profitData" :title="profitTitle" :colors="color" :settings="chartSettings"></ve-ring>
      </div>
    </el-card>
    <el-card class="mr">
      <ve-line :data-empty="sevenEmpty" :title="title"  :xAxis="xAxis" :yAxis="yAxis" :legend="legend"  :data="sevenData"></ve-line>
    </el-card>
    <el-card class="mr" style="height: 600px;">
      <el-form :inline="true" ref="searchForm" :model="form" class="demo-form-inline " label-width="125px">
        <el-form-item label="业务系统" prop="sysId">
          <el-select v-model="form.sysId" multiple collapse-tags  clearable filterable placeholder="请选择业务系统">
            <el-option :label="item.systemName" :value="item.systemId" v-for="(item, $index) in sysData" :key="$index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="统计日期" prop="date">
          <el-date-picker
            v-model="form.date"
            :editable = "editable"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            >
          </el-date-picker>
        </el-form-item>
        <el-form-item class="float-r">
          <el-button type="primary" size="small" @click="onSubmit">查询</el-button>
          <el-button type="primary" size="small" @click="downBill">账单下载</el-button>
        </el-form-item>
      </el-form>
      <!-- <div class="year float">
        <div class="color" @click="httpIncome(item, $index)" v-bind:class="{ red: item.isActive }" v-for="(item, $index) in year" :key="$index">{{item.year}}</div>
      </div>
      <div class="month float">
        <div class="color" @click="httpIncome(item, $index)" v-bind:class="{ red: item.isActive }" v-for="(item, $index) in month" :key="$index">{{item.month}}</div>
      </div> -->
      <div class="inCost float">
        <ve-histogram :extend="extend" :data-empty="dataEmpty" :data="chartData" :dataZoom="dataZoom"></ve-histogram>
      </div>
    </el-card>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
@import "../../assets/sass/base.scss";
.mr {
  margin: 10px;
}
.year {
  width: 4%;
}
.month {
  width: 4%;
}
.inCost {
  width: 92%;
}
.color {
  color: #00c2de;
  margin-top: 15px;
}
.color:hover {
  text-decoration: underline;
  cursor: pointer;
}
.red {
  color: #FF667D;
}
.float {
  float: left;
}
.month {
  /* margin-left: 20px; */
}
.left {
  float: left;
  width: 33%;
  height: 400px;
}
.data-empty {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, .7);
  color: #888;
  font-size: 14px;
}
.ml {
  padding-left: 50px;
  box-sizing: border-box;
}
</style>
<script>
import 'v-charts/lib/style.css'
export default {
  name: 'revenueMarket',
  data () {
    this.chartSettings = {
      radius: [50, 100],
      legendLimit: 0,
      label: {
        formatter: '{b} :{d}%'
      }
    }
    this.extend = {
      series: {
        label: { show: true, position: 'top' },
        barWidth: 80
      }
    }
    return {
      chartData: {
        columns: ['平台', '收入', '成本', '利润'],
        rows: [
        ]
      },
      form: {
        sysId: [],
        date: ''
      },
      dataEmpty: false,
      dataZoom: [
        {
          type: 'slider',
          xAxisIndex: [0]
        },
        {
          type: 'slider',
          yAxisIndex: [0]
        }
      ],
      sevenData: {
        columns: ['日期', '收入', '成本', '收益'],
        rows: [
        ]
      },
      sevenEmpty: false,
      legend: {
        bottom: '0'
      },
      title: {
        text: '七日收益',
        left: 'center'
      },
      xAxis: {
        type: 'category',
        name: '日期',
        nameTextStyle: {
          fontStyle: 'bold',
          fontSize: '16'
        },
        axisLine: {
          onZero: false
        },
        nameGap: 25,
        nameLocation: 'center'
      },
      yAxis: {
        type: 'value',
        name: '金额(元)',
        nameTextStyle: {
          fontStyle: 'bold',
          fontSize: '16'
        },
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        nameGap: 15
      },
      editable: false,
      color: ['#2EC7C9', '#B6A2DE', '#5AB1EF', '#FFB980'],
      incomeEmpty: false,
      costEmpty: false,
      profitEmpty: false,
      incomeTitle: {
        text: '',
        subtext: '',
        itemGap: 20,
        top: '',
        left: 'center',
        textStyle: {
          color: '',
          fontSize: 20
        },
        subtextStyle: {
          color: '',
          fontSize: 16
        }
      },
      profitTitle: {
        text: '',
        subtext: '',
        itemGap: 20,
        top: '',
        left: 'center',
        textStyle: {
          color: '',
          fontSize: 20
        },
        subtextStyle: {
          color: '',
          fontSize: 16
        }
      },
      costTitle: {
        text: '',
        subtext: '',
        itemGap: 20,
        top: '',
        left: 'center',
        textStyle: {
          color: '',
          fontSize: 20
        },
        subtextStyle: {
          color: '',
          fontSize: 16
        }
      },
      incomeData: {
        columns: ['name', 'value'],
        rows: [
        ]
      },
      costData: {
        columns: ['name', 'value'],
        rows: [
        ]
      },
      profitData: {
        columns: ['name', 'value'],
        rows: [
        ]
      }
    }
  },
  computed: {
    sysData () {
      return this.$store.state.sysData
    }
  },
  created () {
    let _this = this
    if (!this.sysData.length) {
      this.$store.dispatch('getSystem') // 请求业务系统
    }
    this.$axios({ // 请求收入 花费 利润
      url: this.$API.analysis.querySystemTotalCostIncome,
      method: 'post',
      data: {}
    }).then((response) => {
      if (response.data && response.data.resData.length) {
        let incomeTotal = 0
        let costTotal = 0
        let profitTotal = 0
        _this.profitEmpty = false
        _this.costEmpty = false
        _this.incomeEmpty = false
        for (let v of response.data.resData) {
          let incomeOp = {}
          let costOp = {}
          let profitOp = {}
          incomeTotal += v.income // 总收入
          costTotal += v.cost // 总成本
          profitTotal += v.profit // 总利润
          incomeOp.name = v.sysName
          incomeOp.value = v.income
          costOp.name = v.sysName
          costOp.value = v.cost
          profitOp.name = v.sysName
          profitOp.value = v.profit
          _this.incomeData.rows.push(incomeOp)
          _this.costData.rows.push(costOp)
          _this.profitData.rows.push(profitOp)
        }
        incomeTotal = (incomeTotal / 10000).toFixed(4)
        costTotal = (costTotal / 10000).toFixed(4)
        profitTotal = (profitTotal / 10000).toFixed(4)
        console.log(_this.incomeData)
        _this.incomeTitle.text = '主营业务收入(万元)'
        _this.incomeTitle.subtext = '￥' + incomeTotal
        _this.incomeTitle.textStyle.color = '#FF6694'
        _this.incomeTitle.subtextStyle.color = '#FF6694'
        _this.costTitle.text = '主营业务成本(万元)'
        _this.costTitle.subtext = '￥' + costTotal
        _this.costTitle.textStyle.color = '#2EC7C9'
        _this.costTitle.subtextStyle.color = '#2EC7C9'
        _this.profitTitle.text = '主营业务利润 (万元)'
        _this.profitTitle.subtext = '￥' + profitTotal
        _this.profitTitle.textStyle.color = '#FFB980'
        _this.profitTitle.subtextStyle.color = '#FFB980'
      } else {
        _this.profitEmpty = true
        _this.costEmpty = true
        _this.incomeEmpty = true
      }
    }).catch((err) => {
      console.log(err)
    })
    this.$axios({
      url: this.$API.analysis.queryLatestSevenDaysCostIncome,
      method: 'post',
      data: {}
    }).then((response) => {
      if (response.data && response.data.resData.length) {
        _this.sevenEmpty = false
        for (let val of response.data.resData) {
          let obj = {}
          obj['日期'] = val.sumDay
          obj['收入'] = val.income
          obj['成本'] = val.cost
          obj['收益'] = val.profit
          _this.sevenData.rows.push(obj)
        }
      } else {
        // _this.sevenData.rows = [
        //   { '日期': '', '收入': '0', '成本': '0', '收益': '0' }
        // ]
        _this.sevenEmpty = true
      }
    }).catch((err) => {
      console.log(err)
    })
    this.querySysProfit()
  },
  methods: {
    getIncomeCost (date) {
      let _this = this
      this.$axios({
        url: _this.$API.analysis.querySpecificMonthSysCostIncome,
        method: 'post',
        data: { month: date }
      }).then((response) => {
        if (response.data && response.data.resData.length) {
          _this.dataEmpty = false
          _this.chartData.rows = []
          for (let val of response.data.resData) {
            let op = {}
            op['平台'] = val.sysName
            op['收入'] = val.income
            op['成本'] = val.cost
            op['利润'] = val.profit
            _this.chartData.rows.push(op)
          }
        } else {
          _this.dataEmpty = true
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    httpIncome (item, index) {
      if (item.month) {
        for (let v of this.month) {
          v.isActive = false
        }
        this.month[index].isActive = true
      } else {
        for (let v of this.year) {
          v.isActive = false
        }
        this.year[index].isActive = true
      }
      let month = ''
      let year = ''
      let date = ''
      for (let val of this.month) {
        if (val.isActive) {
          month = val.month // 获取月份
        }
      }
      for (let val of this.year) {
        if (val.isActive) {
          year = val.year // 获取年份
        }
      }
      if (month && year) {
        date = year + '-' + month
        this.getIncomeCost(date)
      }
    },
    downBill () { // 下载账单
      let url = this.$API.accounting.downloadSysCostIncome
      // let url = 'http://172.16.9.132:5010/agw/statistic/downloadSysCostIncome'
      let op = {}
      let id = this.form.sysId
      op.sysIds = id
      if (!this.form.date) { // 默认展示当前30天数据
        let date = new Date()
        let day = date.getDate()
        let month = date.getMonth() + 1 // 获取当前月份
        let year = date.getFullYear()
        let lastDate = new Date(date - 1000 * 60 * 60 * 24 * 30) // 获取默认前30天时间
        let getLastDay = lastDate.getDate() // 获取默认前30天 天份
        let getLastMonth = lastDate.getMonth() + 1 // 获取默认前30天 月份
        let getLastYear = lastDate.getFullYear() // 获取默认前30天 年份
        op.beginTime = getLastYear + '-' + (getLastMonth < 10 ? '0' + getLastMonth : getLastMonth) + '-' + (getLastDay < 10 ? '0' + getLastDay : getLastDay) + ' 00:00:00'
        op.endTime = year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day) + ' 23:59:59'
      } else {
        op.beginTime = this.form.date ? this.form.date[0] + ' 00:00:00' : ''
        op.endTime = this.form.date ? this.form.date[1] + ' 23:59:59' : ''
      }
      op.mtk = localStorage.getItem('usermtk')
      let form = document.createElement('form')
      form.id = 'form'
      form.name = 'form'
      document.body.appendChild(form)
      for (let obj in op) {
        if (op.hasOwnProperty(obj)) {
          var input = document.createElement('input')
          input.tpye = 'hidden'
          input.name = obj
          input.value = op[obj]
          form.appendChild(input)
        }
      }
      form.method = 'POST' // 请求方式
      form.action = url
      form.submit()
      document.body.removeChild(form)
    },
    querySysProfit () {
      let op = {}
      let id = this.form.sysId
      op.sysIds = id
      if (!this.form.date) { // 默认展示当前30天数据
        let date = new Date()
        let day = date.getDate()
        let month = date.getMonth() + 1 // 获取当前月份
        let year = date.getFullYear()
        let lastDate = new Date(date - 1000 * 60 * 60 * 24 * 30) // 获取默认前30天时间
        let getLastDay = lastDate.getDate() // 获取默认前30天 天份
        let getLastMonth = lastDate.getMonth() + 1 // 获取默认前30天 月份
        let getLastYear = lastDate.getFullYear() // 获取默认前30天 年份
        op.beginTime = getLastYear + '-' + (getLastMonth < 10 ? '0' + getLastMonth : getLastMonth) + '-' + (getLastDay < 10 ? '0' + getLastDay : getLastDay) + ' 00:00:00'
        op.endTime = year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day) + ' 23:59:59'
      } else {
        op.beginTime = this.form.date ? this.form.date[0] + ' 00:00:00' : ''
        op.endTime = this.form.date ? this.form.date[1] + ' 23:59:59' : ''
      }
      let _this = this
      this.$axios({
        url: _this.$API.analysis.querySpecificMonthSysCostIncome,
        // url: 'http://172.16.9.132:5010/agw/statistic/querySpecificMonthSysCostIncome',
        method: 'post',
        data: op
      }).then((response) => {
        if (response.data && response.data.resData.length) {
          _this.dataEmpty = false
          _this.chartData.rows = []
          for (let val of response.data.resData) {
            let op = {}
            op['平台'] = val.sysName
            op['收入'] = val.income
            op['成本'] = val.cost
            op['利润'] = val.profit
            _this.chartData.rows.push(op)
          }
        } else {
          _this.dataEmpty = true
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    onSubmit () {
      this.querySysProfit()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/analysis/revenueAnalysis.vue